import React from "react";
import "./index.scss";
import { Lifebuoy, LineSegments } from "phosphor-react";

const Guides = () => {
  // for future use
  // const handleTutorialLink = () => {
  //   window.open(
  //     "https://www.youtube.com/channel/UCnGBghXDc1iHGbAfT6p4b0A",
  //     "_blank"
  //   );
  //   window.focus();
  // };
  return (
    <div className="guides" data-testid="guides">
      <div className="guide-card" data-testid="tutorial-link">
        <div className="guide-header">
          <LineSegments size={24} color="#8A8E99" />
          <p className="label">Good place to start</p>
        </div>
        <p className="description">
          Head over on our{" "}
          <a href="/store" className="store">
            store page
          </a>{" "}
          and see what we can do and offer to kickstart your farming needs.
        </p>
      </div>
      <div
        className="guide-card"
        data-testid="help-center"
        onClick={() => {}}
        aria-hidden
      >
        <div className="guide-header">
          <Lifebuoy size={24} color="#8A8E99" />{" "}
          <p className="label">Help center</p>
        </div>
        <p className="description">
          Contact us at{" "}
          <a className="email" href="mailto:support@datafarming.com.au">
            support@datafarming.com.au
          </a>{" "}
          if you have any questions or just need some advice on how to get
          started.
        </p>
      </div>
      {/* FOR FUTURE USE */}
      {/* <div className="divider" />
      <div className="guide-card" data-testid="whats-new">
        <Hourglass size={20} color="#8A8E99" />
        <h2 className="title">What’s New</h2>
        <p className="description">
          Curious about what we’re building? Stay up to date for the things we
          can offers.
        </p>
      </div> */}
    </div>
  );
};
Guides.propTypes = {};
export default Guides;
